import { ArrowDownward } from '@mui/icons-material';
import type { PlayerResponse } from '@on3/api';
import {
  type ColumnOption,
  getColumnHeaderList,
  SortFilter,
} from '@public/components/Db/Filters/SortFilter';
import { useCallback } from 'react';

import styles from './CommitColumnHeader.module.scss';

interface ICommitColumnHeadersProps {
  selected: keyof PlayerResponse | string;
  onChange?: React.MouseEventHandler<HTMLButtonElement>;
  ascending: boolean;
  noSorting?: boolean;
}
const columns: ColumnOption[] = [
  'lastName',
  'position',
  'nilValue',
  'rating',
  'date',
  'athleteVerified',
];
const headerListSelection = getColumnHeaderList(columns);

export const CommitColumnHeaders = ({
  selected,
  onChange,
  ascending,
  noSorting,
}: ICommitColumnHeadersProps) => {
  const handleClick: React.MouseEventHandler<HTMLButtonElement> = useCallback(
    (e) => {
      onChange?.(e);
    },
    [onChange],
  );

  return (
    <>
      {!noSorting && (
        <div className={styles.mobileSort}>
          <SortFilter
            ascending={ascending}
            handleSort={handleClick}
            key={`${selected}-${ascending}`}
            selected={selected}
            sortList={headerListSelection}
          />
        </div>
      )}

      <div className={styles.block}>
        <ul>
          {headerListSelection.map((item) => {
            if (item.dropDownOnly) return null;
            const isSelected = item.name === selected;

            return (
              <li data-name={item.displayName} key={item.key}>
                {noSorting ? (
                  <div
                    className={styles.btnHeader}
                    data-active={isSelected}
                    data-ascending={item.flipDirection ? !ascending : ascending}
                    data-flip={item.flipDirection}
                    data-sorttype={item.name}
                  >
                    {item.displayName}
                    {isSelected && <ArrowDownward />}
                  </div>
                ) : (
                  <button
                    className={styles.btnHeader}
                    data-active={isSelected}
                    data-ascending={item.flipDirection ? !ascending : ascending}
                    data-flip={item.flipDirection}
                    data-sorttype={item.name}
                    onClick={handleClick}
                  >
                    {item.displayName}
                    {isSelected && <ArrowDownward />}
                  </button>
                )}
              </li>
            );
          })}
        </ul>
      </div>
    </>
  );
};
